
import React from 'react';
import { Link } from 'react-router-dom';

const STATS = [
  { n: '48 h', l: 'activation' },
  { n: '0€', l: "d'inscription" },
  { n: '100%', l: 'en ligne' },
  { n: '24/7', l: 'réservations' },
];

const ProBannerSection = () => (
  <section className="max-w-[1280px] mx-auto px-4 sm:px-6 pt-10 sm:pt-20 pb-4">
    <div
      className="relative rounded-3xl overflow-hidden grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] gap-10 items-center px-5 sm:px-12 lg:px-16 py-8 sm:py-14 text-white"
      style={{ background: 'linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)' }}
    >
      {/* Decorative blob */}
      <div className="absolute w-80 h-80 rounded-full pointer-events-none" style={{ background: 'rgba(255,255,255,.10)', top: '-100px', right: '20%' }} />

      {/* Left: copy */}
      <div className="relative z-10">
        <span className="inline-block bg-white/22 rounded-pill px-3 py-1 text-xs font-semibold uppercase tracking-wider mb-3.5">
          Espace pro
        </span>
        <h2
          className="font-heading font-extrabold text-white leading-[1.1] tracking-tight mb-3.5"
          style={{ fontSize: 'clamp(28px, 3.2vw, 38px)', letterSpacing: '-0.02em' }}
        >
          Vous gérez un lieu&nbsp;?<br />Remplissez vos créneaux vides.
        </h2>
        <p className="text-[16px] leading-relaxed text-white/92 mb-6 max-w-[50ch]">
          Référencez votre établissement sur FullBook et touchez des groupes qui cherchent exactement ce que vous proposez. Activation en 48&nbsp;h, sans engagement.
        </p>
        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/pro"
            className="bg-white text-brand-text font-bold px-6 py-3 rounded-lg text-[14px] hover:bg-white/90 transition-colors"
          >
            Devenir Pro →
          </Link>
          <Link
            to="/pro-dashboard"
            className="bg-white/15 border border-white/40 text-white font-semibold px-5 py-3 rounded-lg text-[14px] hover:bg-white/25 transition-colors"
          >
            Voir un exemple
          </Link>
        </div>
      </div>

      {/* Right: stats mini-cards */}
      <div className="relative z-10 grid grid-cols-2 gap-4">
        {STATS.map(({ n, l }) => (
          <div key={l} className="bg-white/14 rounded-xl px-3 sm:px-5 py-3 sm:py-4 backdrop-blur-sm">
            <div className="font-heading font-extrabold text-[22px] sm:text-[28px] tracking-tight leading-tight">{n}</div>
            <div className="text-[12px] text-white/85 mt-0.5">{l}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ProBannerSection;
